module.exports = __webpack_public_path__ + "static/media/aplicativo.de7f0e0d.svg";